




























import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import BaseComments from '@/components/common/BaseComments.vue'
import BaseImage from '@/components/common/BaseImage.vue'
import BaseSocialSharing from '@/components/common/BaseSocialSharing.vue'

@Component( {
    computed: mapGetters( {
        associationById: 'associationsModule/associationById',
        userByUid: 'usersModule/userByUid'
    } ),
    components: {
        'oe-base-comments': BaseComments,
        'oe-base-image': BaseImage,
        'oe-base-social-sharing': BaseSocialSharing
    }
} )
export default class AssociationDetailOverlay extends Vue {
    associationId: string | null = null
    associationDetailActive = false
    userByUid!: any
    associationById!: any

    get relatedUser() {
        return this.userByUid( this.associationById( this.associationId ).created_by )
    }

    get relatedAssociation() {
        return this.associationById( this.associationId )
    }

    showOverlay( id: string ) {
        this.associationId = id
        this.associationDetailActive = true

        this.$store.commit( 'globalModule/setBodyFixed' )
    }

    closeOverlay( event: Event ) {
        event.preventDefault()

        this.associationDetailActive = false
        this.$store.commit( 'globalModule/setBodyFixed' )
    }
}
